import { getUrl } from '@buffer-mono/shared-utils/bibe'

import type { Service } from '~publish/contexts/AccountContext/graphqlEnums'
import {
  connectChannel,
  toConnectableService,
} from '~publish/helpers/channelConnections'
import { navigateTo } from '~publish/helpers/navigation'
import { useStartPageSunsetAnnouncementEnabled } from '~publish/hooks/useStartPageSunsetAnnouncementEnabled'

export const useConnectChannel = ({
  cta,
  destinationUrl,
}: {
  cta: string
  destinationUrl?: string
}): ((service: Service) => void) => {
  const isStartPageSunset = useStartPageSunsetAnnouncementEnabled()

  const onChannelClick = (service: Service): void => {
    if (service === 'startPage') {
      // New Start Pages can no longer be created once the sunset is announced.
      if (isStartPageSunset) return
      setTimeout(() => {
        navigateTo(getUrl('https://start-page.buffer.com/onboarding'))
      }, 200)
      return
    }

    const connectableService = toConnectableService(service)
    if (!connectableService) return

    connectChannel({
      service: connectableService,
      cta,
      destinationUrl,
    })
  }

  return onChannelClick
}
